import React, { useState } from 'react'
import classNames from 'classnames'
import PasswordIcon from './icons/password'
import { ReactComponent as WrongPassword } from 'assets/icons/WrongPassword.svg'
import InputWrapper from './inputWrapper'

const Input = ({
  type,
  iconLeft,
  error,
  iconRight,
  label,
  handleError = true,
  textarea = false,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const inputHeight = 'h-12 2xl:h-12'

  const inputClasses = classNames(
    'w-full	border rounded-5 focus:ring-0 focus:outline-none p-7 py-4',
    'text-base font-regular border-blue-80 bg-white active:bg-white',
    textarea ? 'resize-none' : inputHeight,
    error && `border-[#DC143C] border-2 focus:border-[#DC143C]`,
    iconLeft && 'pl-16',
  )

  return (
    <InputWrapper
      error={error}
      iconRight={iconRight}
      iconLeft={iconLeft}
      label={label}
      handleError={handleError}
      classes={{ iconRight: textarea ? `top-0 ${inputHeight}` : undefined }}
    >
      {textarea ? (
        <textarea className={inputClasses} {...rest} />
      ) : (
        <input
          className={inputClasses}
          type={type === 'password' && showPassword ? 'text' : type}
          {...rest}
        />
      )}
      {type === 'password' && (
        <div
          className="absolute inset-y-0 right-5 flex items-center justify-center"
          onClick={() => setShowPassword(!showPassword)}
        >
          <button type="button" className="focus:outline-none ">
            {!error ? (
              <PasswordIcon fill="#111136" width="25px" />
            ) : (
              <WrongPassword className="w-6" />
            )}
          </button>
        </div>
      )}
    </InputWrapper>
  )
}

export default Input
